import {
  ConditionalTemplate as ConditionalTemplateComponent,
  type CustomTemplateProps,
} from '../../widget-components'
import styles from './ConditionalTemplate.module.scss'

const ConditionalTemplateWidget = (props: CustomTemplateProps) => {
  return (
    <div className={styles.root}>
      <ConditionalTemplateComponent {...props} />
    </div>
  )
}

export default ConditionalTemplateWidget
